import axios from 'axios';

// TODO: Remove this after the app has been converted to TS
// New TS based files should use the Provider type which is camelCased
// and not the legacy rails underscore cased model fields
const railsDataConverter = (provider) => {
  provider.practice_address = provider.practiceAddress;
  provider.fax_number = provider.faxNumber;
  provider.signature_base64 = provider.signatureBase64;
  provider.phone_number = provider.phoneNumber;
  provider.full_title_name = provider.fullTitleName;
  provider.payment_code_type = provider.paymentCodeType;
  provider.cpso_id = provider.cpsoId;
  provider.cpsa_id = provider.cpsaId;
  provider.bc_cps_id = provider.bcCpsId;
  provider.bc_msp_id = provider.bcMspId;
  provider.ohip_id = provider.ohipId;
  provider.ab_prac_id = provider.abPracId;
  provider.state_or_province = provider.stateOrProvince;
  provider.dea_id = provider.deaId;
  provider.npi_id = provider.npiId;
  provider.time_zone = provider.timeZone;
  provider.adracare_token = provider.adracareToken;
  provider.adracare_provider_id = provider.adracareProviderId;
  provider.adracare_account_id = provider.adracareAccountId;
  provider.last_external_appointment_sync = provider.lastExternalAppointmentSync;

  return provider;
};

export const getProvider = async (token) => {
  const apiURL = process.env.REACT_APP_APIV2 + '/apiv2/provider';

  const requestParams = {
    params: {
      token: token,
    },
  };

  const { data, status } = await axios.get(apiURL, requestParams);

  if (status !== 200) {
    throw new Error('getProvider Failed');
  }

  if (data.provider) {
    return railsDataConverter(data.provider);
  } else {
    throw new Error('No Provider Data');
  }
};

// Has try/catch because caller does not use ReactQuery
export const login = async (loginData) => {
  const apiURL = process.env.REACT_APP_APIV2 + '/apiv2/login';
  try {
    const config = {
      headers: { 'Cache-Control': 'no-store' },
    };
    const { data } = await axios.post(apiURL, loginData, config);
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateUser = async (adracareToken, userData) => {
  const apiURL = `${process.env.REACT_APP_APIV2}/apiv2/user?adracareToken=${adracareToken}`;

  const config = {
    headers: { 'Cache-Control': 'no-store' },
  };

  let params = {
    fields: { ...userData },
  };

  const { data, status } = await axios.put(apiURL, params, config);

  if (status !== 200) {
    throw new Error('Update UserInformation Failed');
  }

  return data;
};
